import React, { FC } from 'react'
import { Table, TableBody, TableCell, TableRow } from '@mui/material'
import { ParsedItem } from '../model/ItemParser'

import { sum } from '../utils/Array'
import './TypeStats.css'

type TypeStatsArguments = {
  items: Array<ParsedItem>
}

const calculateTotalVolume = (items: Array<ParsedItem>): number =>
  sum(items.map(i => i.volume || 0))

const formatNumber = (n: number) => n.toFixed(1)

const TypeStats: FC<TypeStatsArguments> = (properties: TypeStatsArguments) => (
  <Table>
    <TableBody>
      <TableRow>
        <TableCell>Asteroid</TableCell>
        <TableCell className="quantity">Quantity</TableCell>
        <TableCell className="volume">Volume</TableCell>
        <TableCell className="ratio">Ratio</TableCell>
      </TableRow>
      { properties.items.map((item, index) => <TableRow key={ index }>
        <TableCell>{ item.name }</TableCell>
        <TableCell className="quantity">{ item.count }</TableCell>
        <TableCell className="volume">{ item.volume } m³</TableCell>
        <TableCell className="ratio">{ formatNumber((item.ratio || 0) * 100) }%</TableCell>
      </TableRow>) }
      <TableRow className="total" aria-label="total">
        <TableCell>Total</TableCell>
        <TableCell className="quantity"/>
        <TableCell className="volume" aria-label="total-volume">{ calculateTotalVolume(properties.items) } m³</TableCell>
      </TableRow>
    </TableBody>
  </Table>
)

export default TypeStats
